(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5345,9008,6511,9534,136,3406,9901],{

/***/ 85353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(94254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27429);




var TurnToScript = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
            type: "text/javascript",
            strategy: "afterInteractive",
            onLoad: function() {
                (0,_services_Log__WEBPACK_IMPORTED_MODULE_3__/* .log */ .cM)("TurnTo script loaded");
            },
            src: "https://widgets.turnto.com/v5/widgets/".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_1__.TURNTO_SITE_KEY, "/js/turnto.js")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TurnToScript);


/***/ }),

/***/ 40136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsExtendItem": function() { return /* binding */ checkIsExtendItem; }
/* harmony export */ });
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84749);

var checkIsExtendItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants__WEBPACK_IMPORTED_MODULE_0__.EXTEND_SKU);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsExtendItem);


/***/ }),

/***/ 23406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsShippedShieldItem": function() { return /* binding */ checkIsShippedShieldItem; }
/* harmony export */ });
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84749);

var checkIsShippedShieldItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants__WEBPACK_IMPORTED_MODULE_0__.SHIPPED_SHIELD_SKU);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsShippedShieldItem);


/***/ }),

/***/ 8497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var MOBILE_SCREEN_WIDTH = 768;
var useMobileDetect = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(MOBILE_SCREEN_WIDTH), windowWidth = ref[0], setWindowWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setWindowWidth(window.innerWidth);
        var windowWidthEventListener = function() {
            setWindowWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("resize", windowWidthEventListener);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", windowWidthEventListener);
        };
    }, [
        windowWidth
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isMobile = ref1[0], setIsMobile = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (windowWidth < MOBILE_SCREEN_WIDTH) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobileDetect);


/***/ }),

/***/ 94254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./services/getSiteWideInitialProps.ts + 3 modules
var getSiteWideInitialProps = __webpack_require__(99013);
;// CONCATENATED MODULE: ./hooks/useIsCitizensPayScriptLoaded.ts

var useIsCitizensPayScriptLoaded = function() {
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    (0,react.useEffect)(function() {
        var loadedSetter = function() {
            return setLoaded(true);
        };
        document.addEventListener("CitizensPayScriptLoaded", loadedSetter);
        return function() {
            return document.removeEventListener("CitizensPayScriptLoaded", loadedSetter);
        };
    }, []);
    return loaded;
};
/* harmony default export */ var hooks_useIsCitizensPayScriptLoaded = ((/* unused pure expression or super */ null && (useIsCitizensPayScriptLoaded)));

// EXTERNAL MODULE: ./services/FramedCheckout/thirdPartyServices.ts
var thirdPartyServices = __webpack_require__(48034);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./hooks/useMobileDetect.tsx
var useMobileDetect = __webpack_require__(8497);
// EXTERNAL MODULE: ./components/ScriptIntegrations/TurnToScript.tsx
var TurnToScript = __webpack_require__(74503);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Row.js
var Row = __webpack_require__(69323);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Col.js
var Col = __webpack_require__(79322);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./helpers/productOptionsForSkuMapper.ts





var getVariantOptionsMap = function(variant) {
    return variant.option_values.reduce(function(acc, optionValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, optionValue.option_id, optionValue.id));
    }, {});
};
var getProductVariantOptionsMap = function(variants) {
    return variants.reduce(function(acc, variant) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variant.sku, getVariantOptionsMap(variant)));
    }, {});
};
var scoreMatchBetweenOptionsSets = function(target) {
    return function(option) {
        return Object.entries(target).reduce(function(score, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), optionId = _param[0], optionValue = _param[1];
            return score + (option[optionId] === optionValue ? 1 : 0);
        }, 0);
    };
};
var getSkusLinks = function(optionsValueIds, skusOptionsMap, currentSku) {
    return Object.entries(optionsValueIds).reduce(function(options, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), optionId = _param[0], optionValuesIds = _param[1];
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), (0,_define_property/* default */.Z)({}, optionId, optionValuesIds.reduce(function(optionValues, optionSearchingId) {
            var ref, ref1;
            var idealSetOfOptionValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, skusOptionsMap[currentSku]), (0,_define_property/* default */.Z)({}, optionId, optionSearchingId));
            var skuHasTargetOptionValue = function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), skuMap = _param[1];
                return skuMap[optionId] === optionSearchingId;
            };
            var matchScoreTableForSkusAndOptions = Object.entries(skusOptionsMap).filter(skuHasTargetOptionValue).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), sku = _param[0], candidateOptions = _param[1];
                return [
                    sku,
                    scoreMatchBetweenOptionsSets(idealSetOfOptionValues)(candidateOptions)
                ];
            });
            var hasAtLeastOneMatchedOption = function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), score = _param[1];
                return score > 0;
            };
            var highestScoredSkuForTargetOptionValue = ((ref = matchScoreTableForSkusAndOptions.filter(hasAtLeastOneMatchedOption).sort(function(param, param1) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), scoreA = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), scoreB = _param1[1];
                return scoreB - scoreA;
            })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
            if (!highestScoredSkuForTargetOptionValue) {
                return optionValues;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, optionValues), (0,_define_property/* default */.Z)({}, optionSearchingId, highestScoredSkuForTargetOptionValue));
        }, {})));
    }, {});
};
var getInitialOptions = function() {
    return {};
};
var optionsToOptionsMap = function(optionsInput) {
    return optionsInput.reduce(function(acc, option) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, option.id, option.option_values.map(function(ov) {
            return ov.id;
        })));
    }, getInitialOptions());
};
var productToOptionMapFetcher = function(param) {
    var product = param.product, targetSku = param.targetSku;
    (0,Log/* log */.cM)({
        product: product,
        targetSku: targetSku
    });
    var variantsSkuToOptions = getProductVariantOptionsMap(product.variants);
    var options = optionsToOptionsMap(product.options);
    return getSkusLinks(options, variantsSkuToOptions, targetSku);
};
/* harmony default export */ var productOptionsForSkuMapper = ((/* unused pure expression or super */ null && (productToOptionMapFetcher)));

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/product.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/jsx-props-no-spreading */ 




















var ProductOptions = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1532), __webpack_require__.e(1485), __webpack_require__.e(4832)]).then(__webpack_require__.bind(__webpack_require__, 60134)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60134)
            ];
        }
    }
});
var Default = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(3480), __webpack_require__.e(1587)]).then(__webpack_require__.bind(__webpack_require__, 20882)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20882)
            ];
        }
    }
});
var PdpTrackingServices = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(4528)]).then(__webpack_require__.bind(__webpack_require__, 85919)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85919)
            ];
        }
    }
});
var ProductContextProvider = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(8184)]).then(__webpack_require__.bind(__webpack_require__, 41485)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41485)
            ];
        }
    }
});
var CitizensPayPdpWidget = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(8657)]).then(__webpack_require__.bind(__webpack_require__, 44523)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44523)
            ];
        }
    }
});
var ltkPdpRecEnabled = !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.ltkPdpRecEnabled);
var collectionPdpEnabled = !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.collectionPdpEnabled);
var ListrakRec = ltkPdpRecEnabled ? dynamic_default()(__webpack_require__.e(/* import() */ 2508).then(__webpack_require__.bind(__webpack_require__, 72508)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72508)
            ];
        }
    }
}) : function() {
    return null;
};
var CollectionRecommendationWidget = collectionPdpEnabled ? dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(9961), __webpack_require__.e(1485), __webpack_require__.e(8697)]).then(__webpack_require__.bind(__webpack_require__, 73506)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73506)
            ];
        }
    }
}) : function() {
    return null;
};
var ProductDetails = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(3996), __webpack_require__.e(3906), __webpack_require__.e(1485), __webpack_require__.e(5770), __webpack_require__.e(2771)]).then(__webpack_require__.bind(__webpack_require__, 45811)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45811)
            ];
        }
    }
});
var ProductImages = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(4028)]).then(__webpack_require__.bind(__webpack_require__, 29050)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29050)
            ];
        }
    }
});
var AddProductToCartForm = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(5021), __webpack_require__.e(8883), __webpack_require__.e(1485), __webpack_require__.e(639), __webpack_require__.e(9646), __webpack_require__.e(2654), __webpack_require__.e(7914)]).then(__webpack_require__.bind(__webpack_require__, 34683)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34683)
            ];
        }
    }
});
var Breadcrumbs = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(1230)]).then(__webpack_require__.bind(__webpack_require__, 4716)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4716)
            ];
        }
    }
});
var AccordionProductDetails = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(6860), __webpack_require__.e(3316), __webpack_require__.e(1485), __webpack_require__.e(5475)]).then(__webpack_require__.bind(__webpack_require__, 24041)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24041)
            ];
        }
    }
});
var BrandDescription = dynamic_default()(__webpack_require__.e(/* import() */ 6673).then(__webpack_require__.bind(__webpack_require__, 16673)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16673)
            ];
        }
    }
});
var ProductSchema = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(9762)]).then(__webpack_require__.bind(__webpack_require__, 16926)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16926)
            ];
        }
    }
});
var ProductPage = function(param) {
    var product = param.product, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, defaultVariantSku = param.defaultVariantSku, brand_Info = param.brand_Info, productOptionsToSkuMap = param.productOptionsToSkuMap, imagesToPreload = param.imagesToPreload;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,getSiteWideInitialProps.useClientSideCartAndUser)(), cart = ref6.cart, setCart = ref6.setCart, user = ref6.user;
    var citizensPayScriptLoaded = useIsCitizensPayScriptLoaded();
    var ref7 = (0,react.useState)(Configuration.ENABLE_CITIZENS), shouldShowCitizensPay = ref7[0], setShouldShowCitizensPay = ref7[1];
    var isVintage = (ref = product.warranty) === null || ref === void 0 ? void 0 : (ref3 = ref.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[(ref1 = product.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.sku]) === null || ref4 === void 0 ? void 0 : ref4.is_vintage;
    var isTurnToEnabled = !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.isTurnToEnabled) && !isVintage;
    var isMobile = (0,useMobileDetect/* default */.Z)();
    (0,react.useEffect)(function() {
        var getCitizensDisplayState = function() {
            var citizensPayCookieEnabled = false;
            try {
                // eslint-disable-next-line react-hooks/rules-of-hooks
                citizensPayCookieEnabled = (0,thirdPartyServices.useCitizensPayCookieToggle)();
            } catch (e) {
                (0,Log/* error */.vU)("Failed to check if citizensPayCookie is enabled");
            }
            setShouldShowCitizensPay(Configuration.ENABLE_CITIZENS || citizensPayCookieEnabled);
        };
        getCitizensDisplayState();
    }, []);
    // Computed values from state and props
    var metaTags = {
        title: String(product === null || product === void 0 ? void 0 : product.page_title),
        description: String(product === null || product === void 0 ? void 0 : product.meta_description)
    };
    var brand_description = String((brand_Info === null || brand_Info === void 0 ? void 0 : (ref5 = brand_Info.category) === null || ref5 === void 0 ? void 0 : ref5.meta_description) || "");
    var brand_description_title = "About The Brand";
    var showCitizensPayWidget = shouldShowCitizensPay && citizensPayScriptLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: imagesToPreload.map(function(imgUrl, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: imgUrl,
                        id: "preloaded-image-".concat(index)
                    }, imgUrl);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Default, {
                user: user,
                sitewideBanner: sitewideBanner,
                megaNav: megaNav,
                meta: metaTags,
                cart: cart,
                onUpdateCart: setCart,
                pageType: "product",
                children: [
                    !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.isTurnToEnabled) && isTurnToEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TurnToScript/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                type: "text/javascript",
                                id: "turnto-config",
                                dangerouslySetInnerHTML: {
                                    __html: 'var turnToConfig = {\n                sku:"'.concat(defaultVariantSku, '",\n                locale: "en_US",\n                pageId: "pdp-page",\n              }\n              window.TurnToCmd=window.TurnToCmd||function(){(TurnToCmd.q=TurnToCmd.q||[]).push(arguments)};')
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductContextProvider, {
                        cart: cart,
                        setCart: setCart,
                        product: product,
                        defaultVariantSku: defaultVariantSku,
                        user: user,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdpTrackingServices, {
                                cart: cart,
                                user: user,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                        cols: 1,
                                        "data-currency-code": "USD",
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                                gapX: "lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                        span: 12,
                                                        className: "md:hidden",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {})
                                                    }),
                                                    showCitizensPayWidget && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                        span: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitizensPayPdpWidget, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                        span: {
                                                            sm: 12,
                                                            lg: 7
                                                        },
                                                        className: "w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImages, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.ZP, {
                                                        span: {
                                                            sm: 12,
                                                            lg: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                                                gap: "xl",
                                                                cols: 1,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "hidden md:block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {})
                                                                    }),
                                                                    isTurnToEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        id: "tt-teaser-widget"
                                                                    }),
                                                                    showCitizensPayWidget && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CitizensPayPdpWidget, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                                                                        productOptionsToSkuMap: productOptionsToSkuMap
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddProductToCartForm, {
                                                                        setCart: setCart
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionProductDetails, {})
                                                                ]
                                                            }),
                                                            brand_description && /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandDescription, {
                                                                brand_description_title: brand_description_title,
                                                                brand_description: String(brand_description)
                                                            })
                                                        ]
                                                    }),
                                                    ltkPdpRecEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                        span: {
                                                            sm: 12,
                                                            lg: 12
                                                        },
                                                        className: "w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListrakRec, {})
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }),
                                    collectionPdpEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionRecommendationWidget, {
                                        title: "Related Items"
                                    }),
                                    isTurnToEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-16 mb-4 px-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "tt-reviews-summary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "tt-reviews-list"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSchema, {})
                        ]
                    })
                ]
            })
        ]
    });
};
ProductPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ctx) {
        var ref, query, sku, queryWithoutSlug, ref1, getSiteWideInitialProps, Product, Brand, fetchProductBrand, ref2, ref3, product, brand_Info, siteWideProps, defaultVariantSku, productOptionsToSkuMap, imagesToPreload, params, location, // Tell 302 proxy not to cache response
        // https://docs.layer0.co/guides/caching#section_caching_private_responses
        ref4, ref5, ref6, ref7, ref8, ref9;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    query = ctx.query;
                    sku = String(query.primarySku);
                    queryWithoutSlug = (0,_object_spread/* default */.Z)({}, query);
                    delete queryWithoutSlug.slug;
                    delete queryWithoutSlug.id;
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 10;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99013)),
                            __webpack_require__.e(/* import() */ 1704).then(__webpack_require__.bind(__webpack_require__, 81704)),
                            __webpack_require__.e(/* import() */ 51).then(__webpack_require__.bind(__webpack_require__, 80051)), 
                        ];
                    });
                case 10:
                    _ctx.t1 = _ctx.sent;
                    ref1 = (0, _ctx.t0)(_ctx.t1, 3);
                    getSiteWideInitialProps = ref1[0].getSiteWideInitialProps;
                    Product = ref1[1].Product;
                    Brand = ref1[2].Brand;
                    (0,Log/* log */.cM)("Product page getInitialProps", {
                        sku: sku
                    });
                    fetchProductBrand = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(product) {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!(product === null || product === void 0 ? void 0 : product.brand_id)) {
                                            _ctx.next = 6;
                                            break;
                                        }
                                        _ctx.t0 = product;
                                        _ctx.next = 4;
                                        return Brand.getBrandById(product.brand_id);
                                    case 4:
                                        _ctx.t1 = _ctx.sent;
                                        return _ctx.abrupt("return", [
                                            _ctx.t0,
                                            _ctx.t1
                                        ]);
                                    case 6:
                                        return _ctx.abrupt("return", [
                                            product,
                                            null
                                        ]);
                                    case 7:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function fetchProductBrand(product) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t2 = _sliced_to_array/* default */.Z;
                    _ctx.next = 20;
                    return Promise.all([
                        Product.bySku({
                            sku: sku
                        }).then(fetchProductBrand),
                        getSiteWideInitialProps(ctx), 
                    ]);
                case 20:
                    _ctx.t3 = _ctx.sent;
                    ref2 = (0, _ctx.t2)(_ctx.t3, 2);
                    ref3 = (0,_sliced_to_array/* default */.Z)(ref2[0], 2);
                    product = ref3[0];
                    brand_Info = ref3[1];
                    siteWideProps = ref2[1];
                    if (product) {
                        _ctx.next = 28;
                        break;
                    }
                    throw new Error("Product not found for sku: ".concat(sku));
                case 28:
                    defaultVariantSku = typeof query.sku === "string" ? query.sku : product.variants[0].sku;
                    productOptionsToSkuMap = productToOptionMapFetcher({
                        product: product,
                        targetSku: defaultVariantSku
                    });
                    (0,Log/* log */.cM)("productOptionsMap for ".concat(defaultVariantSku), {
                        defaultVariantSku: defaultVariantSku,
                        productOptionsToSkuMap: productOptionsToSkuMap
                    });
                    imagesToPreload = (((ref = product === null || product === void 0 ? void 0 : product.variants.find(function(v) {
                        return v.sku === defaultVariantSku;
                    })) === null || ref === void 0 ? void 0 : ref.images) || []).map(function(image) {
                        return image.url_square;
                    }).slice(0, 6);
                    return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, siteWideProps), {
                        imagesToPreload: imagesToPreload,
                        productOptionsToSkuMap: productOptionsToSkuMap,
                        defaultVariantSku: defaultVariantSku,
                        product: product,
                        brand_Info: brand_Info
                    }));
                case 35:
                    _ctx.prev = 35;
                    _ctx.t4 = _ctx["catch"](0);
                    (0,Log/* error */.vU)("PDP SSR Failed", _ctx.t4);
                    params = new URLSearchParams({
                        pdpslug: "".concat(String(ctx.asPath || "") || "").replace(/\//g, "")
                    });
                    location = "".concat(Configuration.SHOP_ORIGIN, "/PageNotFound?").concat(String(params));
                    if ( true && window.location.href) {
                        window.location.href = location;
                    } else if (ctx.res) {
                        ;
                        (ref4 = ctx.res) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.setHeader) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, "cache-control", "private");
                        (ref6 = ctx.res) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.writeHead) === null || ref7 === void 0 ? void 0 : ref7.call(ref6, 302, {
                            location: location
                        });
                        (ref8 = ctx.res) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.end) === null || ref9 === void 0 ? void 0 : ref9.call(ref8);
                    }
                    _ctx.next = 43;
                    return new Promise(function(resolve) {
                        return setTimeout(resolve, 15000);
                    }) // Max 15s to redirect
                    ;
                case 43:
                    throw _ctx.t4;
                case 44:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                35
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var product = (ProductPage);


/***/ }),

/***/ 36511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "asyncStandardizeCart": function() { return /* binding */ asyncStandardizeCart; },
/* harmony export */   "getCart": function() { return /* binding */ getCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);








var formCartStandardizer = function(param) {
    var generateLineItemsFromBCCart = param.generateLineItemsFromBCCart, getCustomItems = param.getCustomItems, standardizeCart = param.standardizeCart;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
            var ref, lineItems, customItems, standardizedCart;
            return _codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return generateLineItemsFromBCCart(bcCart);
                    case 3:
                        lineItems = _ctx.sent;
                        customItems = getCustomItems({
                            lineItems: lineItems,
                            customItems: bcCart === null || bcCart === void 0 ? void 0 : (ref = bcCart.lineItems) === null || ref === void 0 ? void 0 : ref.customItems
                        });
                        standardizedCart = standardizeCart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, bcCart), {
                            email: bcCart.email || "",
                            lineItems: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(lineItems).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(customItems))
                        }));
                        return _ctx.abrupt("return", standardizedCart);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(bcCart) {
            return _ref.apply(this, arguments);
        };
    }();
};
var asyncStandardizeCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
        var ref, standardizeCart, generateLineItemsFromBCCart, getCustomItems, standardizer;
        return _codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 6916).then(__webpack_require__.bind(__webpack_require__, 66916)),
                            __webpack_require__.e(/* import() */ 4352).then(__webpack_require__.bind(__webpack_require__, 14352)),
                            __webpack_require__.e(/* import() */ 5729).then(__webpack_require__.bind(__webpack_require__, 9342)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    standardizeCart = ref[0].standardizeCart;
                    generateLineItemsFromBCCart = ref[1].generateLineItemsFromBCCart;
                    getCustomItems = ref[2].getCustomItems;
                    standardizer = formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    });
                    return _ctx.abrupt("return", standardizer(bcCart));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function asyncStandardizeCart(bcCart) {
        return _ref.apply(this, arguments);
    };
}();
var getCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, ref1, Axios, standardizeCart, generateLineItemsFromBCCart, getCustomItems, ref2, assertBCCart, assertBCCarts, data, rawCart, standardizer, standardCart;
        return _codebuild_output_src722736588_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("getCart START");
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 9669).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23)),
                            __webpack_require__.e(/* import() */ 6916).then(__webpack_require__.bind(__webpack_require__, 66916)),
                            __webpack_require__.e(/* import() */ 4352).then(__webpack_require__.bind(__webpack_require__, 14352)),
                            __webpack_require__.e(/* import() */ 5729).then(__webpack_require__.bind(__webpack_require__, 9342)),
                            __webpack_require__.e(/* import() */ 6888).then(__webpack_require__.bind(__webpack_require__, 6888)), 
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    ref1 = ref[0];
                    Axios = ref1.default;
                    standardizeCart = ref[1].standardizeCart;
                    generateLineItemsFromBCCart = ref[2].generateLineItemsFromBCCart;
                    getCustomItems = ref[3].getCustomItems;
                    ref2 = ref[4];
                    assertBCCart = ref2.assertBCCart;
                    assertBCCarts = ref2.assertBCCarts;
                    _ctx.next = 16;
                    return Axios.get("/api/storefront/cart?include=lineItems.physicalItems.options");
                case 16:
                    data = _ctx.sent.data;
                    assertBCCarts(data);
                    rawCart = data[0];
                    if (rawCart) {
                        _ctx.next = 21;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 21:
                    assertBCCart(rawCart);
                    standardizer = formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    });
                    _ctx.next = 25;
                    return standardizer(rawCart);
                case 25:
                    standardCart = _ctx.sent;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("getCart END", {
                        cart: standardCart
                    });
                    return _ctx.abrupt("return", standardCart);
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCart() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (getCart);


/***/ }),

/***/ 79322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var validSelectors = [
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
];
var Col = function Col(_a) {
    var _b = _a.span, span = _b === void 0 ? 1 : _b, start = _a.start, end = _a.end, _c = _a.divRef, divRef = _c === void 0 ? null : _c, style = _a.style, children = _a.children, className = _a.className, rest = __rest(_a, [
        "span",
        "start",
        "end",
        "divRef",
        "style",
        "children",
        "className"
    ]); //  Must be wrapped inside <Row>
    //  span: Number of columns this Column will take on the grid can receive a static number or object per breakpoint
    //    note: the maximum number is the value defined in Parent <Row>'s cols attribute
    //    possible values:  auto(adjust to size) | 1-12 | full
    //    example: {sm: 12, md:6 } => Takes 12 columns on mobile and 6 columns on screen medium and bigger
    //
    //  start:  Use the start-{n} and end-{n} utilities to make an element start or end at the nth grid line. 
    //  end:    Use the start-{n} and end-{n} utilities to make an element start or end at the nth grid line. 
    var set = function set(tailWindClass, obj) {
        if (obj === void 0) {
            obj = NaN;
        }
        if (_typeof(obj) !== "object") {
            if (isNaN(obj)) {
                return "";
            }
            obj = {
                sm: obj
            };
        }
        var classes = "";
        if (_typeof(obj) === "object") {
            Object.entries(obj).filter(function(_a) {
                var _b = __read(_a, 1), i = _b[0];
                return validSelectors.includes(i);
            }).forEach(function(_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                classes += " ".concat(key !== "sm" ? "".concat(key, ":") : "").concat(tailWindClass).concat(value);
            });
        }
        return classes;
    };
    return /*#__PURE__*/ React__default["default"].createElement("div", _extends({
        className: "".concat(set("col-span-", span)).concat(set("col-start-", start)).concat(set("col-end-", end), " ").concat(className || ""),
        ref: divRef,
        style: style
    }, rest), children);
};
__webpack_unused_export__ = Col;
exports.ZP = Col; //# sourceMappingURL=Col.js.map


/***/ }),

/***/ 69323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var Row = function Row(_a) {
    var _b = _a.divRef, divRef = _b === void 0 ? null : _b, _c = _a.cols, cols = _c === void 0 ? 12 : _c, _d = _a.gap, gap = _d === void 0 ? "md" : _d, _e = _a.gapX, gapX = _e === void 0 ? gap : _e, _f = _a.gapY, gapY = _f === void 0 ? gap : _f, children = _a.children, _g = _a.style, style = _g === void 0 ? {} : _g, className = _a.className, rest = __rest(_a, [
        "divRef",
        "cols",
        "gap",
        "gapX",
        "gapY",
        "children",
        "style",
        "className"
    ]);
    var gapDictionary = {
        "xs": "1",
        "sm": "2",
        "md": "4",
        "lg": "6",
        "xl": "8",
        "2xl": "12",
        "3xl": "16"
    };
    var genClasses = function genClasses() {
        var classes = "grid ";
        if (typeof cols === "number") {
            classes += " grid-cols-".concat(cols);
        } else if (_typeof(cols) === "object") {
            classes += " grid-cols-".concat(cols.xs || 12);
            Object.keys(cols).forEach(function(key) {
                if (key !== "xs") {
                    classes += " ".concat(key, ":grid-cols-").concat(cols[key]);
                }
            });
        }
        var addAxisGap = function addAxisGap(classes, gap, separator) {
            if (separator === void 0) {
                separator = "";
            }
            var isSinglySetGap = _typeof(gap) === "object" && Object.keys(gap).length === 1;
            gap = _typeof(gap) === "object" && Object.keys(gap).length < 1 ? "md" : gap;
            if (typeof gap === "string") {
                return classes + " gap".concat(separator, "-").concat(gapDictionary[gap]);
            } else if (isSinglySetGap) {
                return classes + " gap".concat(separator, "-").concat(gapDictionary[gap[Object.keys(gap)[0]]]);
            }
            var gapKeys = [
                "xs",
                "sm",
                "md",
                "lg",
                "xl",
                "2xl",
                "3xl"
            ];
            var defaultASLowestDefinedBreakpoint = gapKeys.find(function(key) {
                return gap === null || gap === void 0 ? void 0 : gap[key];
            });
            var gapMinimumValue = gap === null || gap === void 0 ? void 0 : gap[defaultASLowestDefinedBreakpoint];
            classes += " gap".concat(separator, "-").concat(gapDictionary[gapMinimumValue || "md"]);
            gapKeys.forEach(function(breakpoint) {
                if (breakpoint === defaultASLowestDefinedBreakpoint || !(gap === null || gap === void 0 ? void 0 : gap[breakpoint])) {
                    return;
                }
                var gapValue = gapDictionary[(gap === null || gap === void 0 ? void 0 : gap[breakpoint]) || "md"];
                classes += " ".concat(breakpoint, ":gap").concat(separator, "-").concat(gapValue);
            });
            return classes;
        };
        classes = addAxisGap(classes, gapX, "-x");
        classes = addAxisGap(classes, gapY, "-y");
        return "".concat(classes).concat(className !== undefined ? " ".concat(className) : "");
    };
    return /*#__PURE__*/ React__default["default"].createElement("div", _extends({
        ref: divRef,
        className: genClasses(),
        style: style
    }, rest), children);
};
__webpack_unused_export__ = Row;
exports.ZP = Row; //# sourceMappingURL=Row.js.map


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9080,8924,6934,9013,6778,8034,9774,2888,179], function() { return __webpack_exec__(85353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);